export default "__VITE_ASSET__CD1Z$_Fp__"